/* eslint-disable import/prefer-default-export */
import * as pinia from 'pinia';
import useSessionStore from './useSessionStore';
import { USER_ROLE } from '@/Utils/vice-constants';
import SessionAnalyticsService from '@/Services/SessionAnalyticsService';

const useUsersPresenceStore = pinia.defineStore('UsersPresenceStore', {
  state: () => ({
    presentUsers: [],
  }),
  getters: {
    invitedParticipantEmails: () =>
      useSessionStore()
        .sessionDetails?.invites.filter(
          (invitedUser) => invitedUser.user_role == USER_ROLE.PARTICIPANT,
        )
        .map((participant) => participant.email) || [],

    invitedObserverEmails: () =>
      useSessionStore()
        .sessionDetails?.invites.filter(
          (invitedUser) => invitedUser.user_role == USER_ROLE.OBSERVER,
        )
        .map((participant) => participant.email) || [],

    // participantsList: (state) =>
    //   state.presentUsers.filter(({ email }) => state.invitedParticipantEmails.includes(email)),

    participantsList: (state) =>
      state.presentUsers.filter(
        (userObject) =>
          state.invitedParticipantEmails.includes(userObject.email) &&
          !('role' in userObject) &&
          !userObject.is_offline_participant,
      ),

    // Merges in students/facilitators who joined via mobile "offline participation" (QR/short
    // link, chat-only, no video) - they behave like observers regardless of their invited role.
    observersList: (state) =>
      state.presentUsers.filter(
        (userObject) =>
          !('role' in userObject) &&
          (userObject.is_offline_participant ||
            state.invitedObserverEmails.includes(userObject.email)),
      ),

    cliniciansList: (state) =>
      state.presentUsers.filter(
        (userObject) =>
          useSessionStore().sessionDetails.details.clinician_id === userObject.id &&
          userObject?.role === 'clinician',
      ),

    totalParticipants: (state) => state.participantsList.length,
    totalObservers: (state) => state.observersList.length,
    totalPresentUsers: (state) => state.participantsList.length + state.observersList.length,
  },
  actions: {
    initUsers(allUsers) {
      // Here is the little trick for the first user in the presence channel:
      // In a Laravel Echo server setup, the `joining()` method on a presence channel is fired when a new user joins.
      // However, it does not trigger for the first user joining the channel, because when the channel is initially empty,
      // there is no one for the `joining()` event to broadcast to. Instead, we can handle this by checking for the first
      // user using the `here()` method, which provides the initial list of users in the channel.
      if (Array.isArray(allUsers) && allUsers.length === 1) {
        SessionAnalyticsService.logUserPresence(allUsers[0], 'joined');
      }
      this.presentUsers = allUsers;
    },
    addUser(joiningUser) {
      SessionAnalyticsService.logUserPresence(joiningUser, 'joined');
      this.presentUsers.push(joiningUser);
    },
    removeUser(leavingUser) {
      SessionAnalyticsService.logUserPresence(leavingUser, 'left');
      _.remove(this.presentUsers, (user) => user.unique_id == leavingUser.unique_id);
    },
  },
});
export default useUsersPresenceStore;
